export default (state = [], action) => {
	switch (action.type) {
		case "ADD_TEMPLATE": {
			const newState = state.slice();
			newState.push(action.template);
			return newState;
		}
		case "UPDATE_TEMPLATE": {
			const newState = state.slice();
			for (let i = 0; i < newState.length; i++) {
				if (newState[i].id == action.template.id) {
					newState[i] = action.template;
				}
			}
			return newState;
		}
		case "REMOVE_TEMPLATE": {
			const newState = [];
			for (let i = 0; i < state.length; i++) {
				if (state[i].id != action.id) {
					newState.push(state[i]);
				}
			}
			return newState;
		}
		default:
			return state;
	}
};
